export default __webpack_public_path__ + "static/media/Icon22.0339d36f.svg";